/*
 * @Author: lzy
 * @Date: 2019-11-13 11:19:08
 * @LastEditTime: 2019-11-17 16:47:21
 * @LastEditors: Please set LastEditors
 * @Description: 头条号号
 * @FilePath: \xjmediacloud\app\editingCenter\Toutiaohao\Toutiaohao.js
 */
angular.module("editCenterToutiaohaoBuildingModule", ["toutiaohaoBuildingRouterModule"]).controller("editCenterToutiaohaoBuildingCtrl", ['$scope', '$state', function($scope, $state) {

}])